import { humanizeToFarsi } from "@/components/utilities";

export const AndroidGeneratorInfoCard = (data, allData, history, platform) => {
    const value = function (type) {
        let newData;
        if (!data) {
            if (type === "historical") return [];
            return null;
            // eslint-disable-next-line no-prototype-builtins
        } else if (data && data.constructor.prototype.hasOwnProperty("map")) {
            newData = [...data];
        } else {
            newData = { ...data };
        }

        if (type === "apps" || type === "unreleased_apps") newData = allData;

        return humanizeToFarsi(newData[type]);
    };
    const cardsList = [
        {
            value: value("installs"),
            icon: "mobile_color",
            info: [
                {
                    title: "کل نصب‌ها",
                    value: value("installs"),
                },
                {
                    title: "نصب‌ دردسترس",
                    value: value("transactional_installs"),
                },
            ],
            buttonText: "مشاهده آمار نصب‌ها",
            onClick: () => history.push("/installation/android"),
        },
        {
            value: value("transactional_unique"),
            icon: "user_color",
            info: [
                {
                    title: "کاربر دردسترس",
                    value: value("transactional_unique"),
                },
            ],
            buttonText: "مشاهده آمار کاربران",
            onClick: () => history.push("/user/android"),
        },
        {
            value: value("apps"),
            icon: "app_color",
            info: [
                {
                    title: "اپلیکیشن‌ها",
                    value: value("apps"),
                },
                {
                    title: "اپلیکیشن منتشر‌نشده",
                    value: value("unreleased_apps"),
                },
            ],
            buttonText: "اپلیکیشن جدید",
            onClick: () => history.push(`/application/${platform}/create`),
        },
        {
            value: value("recipients"),
            icon: "notification_color",
            info: [
                {
                    title: "نوتیفیکیشن فرستاده شده",
                    value: value("recipient"),
                },
                // TODO: uncomment these lines
                // {
                //     title: 'نوتیفیکیشن دریافت شده',
                //     value: value('delivered')
                // }
            ],
            buttonText: "ارسال نوتیفیکیشن",
            onClick: () => history.push("/notification/android/create"),
        },
    ];
    return cardsList;
};
